"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isACLError = exports.isErrorWithMessage = exports.DayOfWeek = exports.AUDIENCES = void 0;
const olympus_1 = require("olympus");
__exportStar(require("./cuisines"), exports);
/** @deprecated Please use OlympusConstants.auth.AUDIENCES */
exports.AUDIENCES = olympus_1.OlympusConstants.auth.AUDIENCES;
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Sunday"] = "sunday";
    DayOfWeek["Monday"] = "monday";
    DayOfWeek["Tuesday"] = "tuesday";
    DayOfWeek["Wednesday"] = "wednesday";
    DayOfWeek["Thursday"] = "thursday";
    DayOfWeek["Friday"] = "friday";
    DayOfWeek["Saturday"] = "saturday";
})(DayOfWeek || (exports.DayOfWeek = DayOfWeek = {}));
const isErrorWithMessage = (payload) => {
    return typeof payload === 'object' && !!payload && 'message' in payload;
};
exports.isErrorWithMessage = isErrorWithMessage;
const isACLError = (payload) => {
    return (typeof payload === 'object' &&
        !!payload &&
        payload.name === 'ACLError');
};
exports.isACLError = isACLError;
//# sourceMappingURL=index.js.map